import Vue from "vue"
import { AclInstaller, AclCreate, AclRule } from "vue-acl"
import router from "@/router"

Vue.use(AclInstaller)

let initialRole = "admin"

let userInfo = JSON.parse(localStorage.getItem("userInfo"))
if(userInfo && userInfo.userRole) initialRole = userInfo.userRole

export default new AclCreate({
  initial: initialRole,
  notfound: "/pages/not-authorized",
  router,
  acceptLocalRules: true,
  globalRules: {
    superadmin: new AclRule("superadmin").generate(),
    admin: new AclRule("admin").or("superadmin").generate(),
    editor: new AclRule("editor").or("admin").or("superadmin").generate(),
    public: new AclRule("public").or("admin").or("editor").or("superadmin").generate(),
  }
})
